export const LABELS_DEVICE_OPERATIONS_STATISTIC = {

    name: 'Планова оперативна статистика',
    agencyName: 'Перевізник',
    sumVoyageSchedule: 'По розкладах',
    sumAllVoyagePlanned: 'Всього(заплановано)',
    sumVoyageInRoute: 'На маршруті',
    sumVoyageNotInRoute: 'Не на маршруті',
    sumVoyageGpsFailed: 'Не передають сигнал',
    sumVoyageGpsSuccess: 'Передають сигнал',
    sumVoyageNotScheduled: 'Не заплановано',
    routeDescription: 'Маршрут',
    licensePlate: 'Держ.номер',
    ordinal: 'Маршрут',
    scheduleId: 'Випуск',
    status: 'Статус',
    filtersStatusesVoyage: 'Фільтри статусів маршруту',
    filtersData: 'Фільтри даних',
    withoutStatusFilters: 'Без фільтру',
    byDevices: 'Планова оперативна статистика(по об\'єктам)',
    rootFilters: 'Базові фільтри',
    lastEventTime: 'Час останніх даних',
    dateWithoutSignal: 'Період без передачі сигналу',
    statuses: {
        inRoute: 'На маршруті',
        gpsError: 'Не передає gps',
        notInRoute: 'За маршрутом',
        notPlanned: 'Не запланований',
        green: 'Виходили на зв\'язок до 15 хв тому',
        yellow: 'Виходили на зв\'язок від 15 хв до години',
        red: 'Більше години не підключалися',
    },
    filterStatuses: {
        statusVoyagesGood: 'Все добре по всім параметрам',
        statusVoyagesAverage: 'Середньо(Рядки в яких хоча б 1 елемент є жовтого кольору)',
        statusVoyagesPoor: 'Погано(Рядки в яких хоча б 1 елемент є червоного кольору)',

        statusAfpsDeviceAverage: 'Середньо по валідаторам водія(Рядки в яких хоча б 1 елемент є жовтого кольору)',
        statusAfpsDevicePoor: 'Погано по валідаторам водія(Рядки в яких хоча б 1 елемент є червоного кольору)',


        statusAfpsSelfServiceAverage: 'Середньо по валідаторам самообслуговування(Рядки в яких хоча б 1 елемент є жовтого кольору)',
        statusAfpsSelfServicePoor: 'Погано по валідаторам самообслуговування(Рядки в яких хоча б 1 елемент є червоного кольору)',


        sumAllVoyagePlannedGood: 'Всього(добре)',
        sumVoyageInRouteGood: 'На маршруті (добре)',
        sumVoyageNotInRouteGood: 'Не на маршруті (добре)',
        sumVoyageGpsFailedGood: 'Не передають сигнал (добре)',
        sumVoyageNotScheduledGood: 'Не заплановано (добре)',

        sumAllVoyagePlannedAverage: 'Всього (середньо)',
        sumVoyageInRouteAverage: 'На маршруті (середньо)',
        sumVoyageNotInRouteAverage: 'Не на маршруті (середньо)',
        sumVoyageGpsFailedAverage: 'Не передають сигнал (середньо)',
        sumVoyageNotScheduledAverage: 'Не заплановано (середньо)',

        sumAllVoyagePlannedPoor: 'Всього (погано)',
        sumVoyageInRoutePoor: 'На маршруті (погано)',
        sumVoyageNotInRoutePoor: 'Не на маршруті (погано)',
        sumVoyageGpsFailedPoor: 'Не передають сигнал (погано)',
        sumVoyageNotScheduledPoor: 'Не заплановано (погано)',
    },

}